import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { isOdulOneriIkAuthorized } from '../helper/authorizedUsers'

/** Ödül Öneri İK ekranları — login + allowlist */
const OdulOneriIkRoute = () => {
  const { currentUser } = useSelector((state) => state.auth)

  if (!currentUser) {
    return <Navigate to="/login" />
  }

  if (!isOdulOneriIkAuthorized(currentUser)) {
    return <Navigate to="/access-denied" />
  }

  return <Outlet />
}

export default OdulOneriIkRoute
